// Maps a route pattern to the title shown in the browser tab, so pages are
// distinguishable when an admin/customer has several open at once. Matched
// in order with react-router's matchPath, so a static path must be listed
// before a dynamic sibling that would otherwise shadow it (e.g.
// "/admin/shipments/add" before "/admin/shipments/:id").
const PAGE_TITLES = [
  { path: "/track/:trackingId?", title: "Track Shipment" },

  { path: "/login", title: "Log In" },
  { path: "/register", title: "Register" },
  { path: "/verify-email", title: "Verify Email" },
  { path: "/forgot-password", title: "Forgot Password" },
  { path: "/reset-password", title: "Reset Password" },

  { path: "/admin", title: "Dashboard" },
  { path: "/admin/shipments/add", title: "Add Shipment" },
  { path: "/admin/shipments/bulk-add", title: "Bulk Add Shipments" },
  { path: "/admin/shipments/bulk-import", title: "Bulk Import Shipments" },
  { path: "/admin/shipments/:id", title: "Shipment Details" },
  { path: "/admin/shipments", title: "Shipments" },
  { path: "/admin/customers/:id", title: "Customer Details" },
  { path: "/admin/customers", title: "Users Management" },
  { path: "/admin/customs-doc-templates", title: "Customs Document Templates" },
  { path: "/admin/customs", title: "Customs" },
  { path: "/admin/sailing/:id/manifest", title: "Manifest" },
  { path: "/admin/sailing/:id/freight-allocation", title: "Freight Allocation" },
  { path: "/admin/sailing/:id/house-bol/:customerId", title: "House BOL" },
  { path: "/admin/sailing/:id", title: "Sailing Details" },
  { path: "/admin/sailing", title: "Sailings" },
  { path: "/admin/invoice-rates", title: "Invoice Rates" },
  { path: "/admin/containers", title: "Containers" },
  { path: "/admin/vehicles/:id", title: "Vehicle Details" },
  { path: "/admin/vehicles", title: "Vehicles" },
  { path: "/admin/bol-upload", title: "BOL Upload" },
  { path: "/admin/delivery-receipts/:id/print", title: "Delivery Receipt" },
  { path: "/admin/delivery-receipts", title: "Delivery Receipts" },
  { path: "/admin/delivery-receipt-template", title: "Delivery Receipt Template" },
  { path: "/admin/generate-invoice", title: "Generate Invoice" },
  { path: "/admin/invoices/:id/print", title: "Invoice" },
  { path: "/admin/invoices", title: "Invoices" },
  { path: "/admin/invoice-template", title: "Invoice Template" },
  { path: "/admin/promos", title: "Promos" },
  { path: "/admin/payments", title: "Payments" },
  { path: "/admin/expenses", title: "Expenses" },
  { path: "/admin/consolidations", title: "Consolidations" },
  { path: "/admin/integrations", title: "Integrations" },
  { path: "/admin/upgrade-page", title: "Upgrade Page" },
  { path: "/admin/reports", title: "Reports" },
  { path: "/admin/stats", title: "Stats" },
  { path: "/admin/email-templates", title: "Email Templates" },
  { path: "/admin/email-logs", title: "Email Logs" },
  { path: "/admin/settings", title: "Settings" },
  { path: "/admin/notifications", title: "Notifications" },
  { path: "/admin/shopper-rates", title: "Shopper Rates" },
  { path: "/admin/codes", title: "Codes" },
  { path: "/admin/unclaimed-packages", title: "Unclaimed Packages" },
  { path: "/admin/dock-receipts", title: "Dock Receipts" },
  { path: "/admin/scan/log", title: "Scan Logs" },
  { path: "/admin/scan/in", title: "Scan In" },
  { path: "/admin/scan/out", title: "Scan Out" },
  { path: "/admin/scan/:mode", title: "Warehouse Scan" },
  { path: "/admin/scan", title: "Warehouse Scan" },
  { path: "/admin/item-tracking", title: "Item Tracking" },
  { path: "/admin/ready-to-sail", title: "Ready to Sail" },
  { path: "/admin/status-settings", title: "Status Settings" },
  { path: "/admin/live-traffic", title: "Live Traffic" },
  { path: "/admin/referrals", title: "Referrals" },

  { path: "/dashboard", title: "Dashboard" },
  { path: "/dashboard/shipment/add", title: "Add Shipment" },
  { path: "/dashboard/shipment/:id/edit", title: "Edit Shipment" },
  { path: "/dashboard/shipments/bulk-add", title: "Bulk Add Shipments" },
  { path: "/dashboard/shipments/bulk-import", title: "Bulk Import Shipments" },
  { path: "/dashboard/shipments/:id", title: "Shipment Details" },
  { path: "/dashboard/shipments", title: "My Shipments" },
  { path: "/dashboard/consolidations", title: "Consolidations" },
  { path: "/dashboard/upload/:shipmentId?", title: "Upload Documents" },
  { path: "/dashboard/rates", title: "Rates" },
  { path: "/dashboard/promos", title: "Promos" },
  { path: "/dashboard/referrals", title: "Referrals" },
  { path: "/dashboard/upgrade", title: "Upgrade" },
  { path: "/dashboard/payments", title: "Payments" },
  { path: "/dashboard/invoices/:id/print", title: "Invoice" },
  { path: "/dashboard/notifications", title: "Notifications" },
  { path: "/dashboard/profile", title: "Profile" },

  { path: "/rider", title: "Available Deliveries" },
  { path: "/rider/mine", title: "My Deliveries" },
  { path: "/rider/deliver/:id", title: "Confirm Delivery" },
];

export default PAGE_TITLES;
